// extracted by mini-css-extract-plugin
export default {"formContainer":"ideahub_formContainer__IRPNa","heading":"ideahub_heading__zCen+","divider":"ideahub_divider__gjIgi","buttonContainer":"ideahub_buttonContainer__ZmJLT"};